import { Api, Configuration } from '../../api';
import { apis } from '@/Util/globals';

export const getCacheHeaders = (isAuthor?: boolean, doNotCache?: boolean, fetchTTL?: string) => {
  return {
    ...(!isAuthor && !doNotCache
      ? { next: { revalidate: fetchTTL ? parseInt(fetchTTL, 10) : 300 } }
      : { next: { revalidate: 0 } })
  };
};

const api = new Api(
  new Configuration({
    basePath: apis.base,
    fetchApi: fetch,
    username: process.env.MAGNOLIA_AUTH_USER,
    password: process.env.MAGNOLIA_AUTH_PASSWORD
  })
);
export default api;
